import React from 'react'
import {RouteComponentProps} from 'react-router-dom'

import {Navigator} from '@progyny/components/Navigator'
import {
  SetupProfileMutationVariables,
  SetupMenopauseProfileMutationVariables,
  SetupPregnancyPostpartumProfileMutationVariables,
} from '@progyny/generated/graphql'
import {OnBoardingData} from '@progyny/store/meStore'

export enum SetupProfileRoutes {
  BIRTH_ASSIGNED_SEX,
  GENDER_IDENTITY,
  RELATIONSHIP_DYNAMIC,
  FAMILY_FORMING_JOURNEY,
  COMPLETE = 4,
}

export type SetupProfileSubProps = {
  navigator: typeof Navigator
  callback: () => void
  onboardingData: OnBoardingData
  updateLoading: boolean
  persistMemberData: (
    variables:
      | SetupProfileMutationVariables
      | SetupMenopauseProfileMutationVariables
      | SetupPregnancyPostpartumProfileMutationVariables,
    onSuccess: React.Dispatch<void>
  ) => void
  goBack: () => void
  navigateTo: (page: SetupProfileRoutes, baseUrl: string) => void
} & Pick<RouteComponentProps, 'match' | 'history'>

export type SetupProfileSubPropsSubRoute = {
  path: string
  // Set CreateAccountSubProps as base class
  component: React.ComponentType<SetupProfileSubProps>
  headerTitle?: string
  showProgressBar?: boolean
  description?: string
}

export type PushButtonData = {
  label: string
  value: string
}
